'use client';

import * as a$1 from "react";
import p from "../lib/IconBase.es.js";
import t from "../defs/Flag.es.js";
const a = a$1.forwardRef((e, r) => /* @__PURE__ */ a$1.createElement(p, { ref: r, ...e, weights: t }));
a.displayName = "FlagIcon";
const n = a;
export {
  n as Flag,
  a as FlagIcon
};
